(function () {
    'use strict';

    /**
     * Slider gallery section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_SliderGallery.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "sliderGallerySection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionSliderGallery', sectionSliderGallery);

    function sectionSliderGallery() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionSliderGalleryCtrl,
            controllerAs: 'sliderGallerySection'
        };
    }

    SectionSliderGalleryCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionSliderGalleryCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the gallery images of the event (not language dependent)
         * @param {number} eventId
         * @returns {Promise<boolean>} true when data was received
         */
        function load(eventId) {
            return ApiFactory.GetGalleryImages(eventId).then(function (response) {
                if (response.data == null)
                    return false;

                vm.items = response.data;
                return true;
            });
        }
    }
})();
